import { useMemo } from 'react'

import Head from 'next/head'

import { useLocale } from '@/context/localeContext'
import { useNavigation } from '@/context/navigationContext'

export type MetadataOverrideProps = {
  ogTitle?: string
  ogDescription?: string
  ogImage?: string
  twitterTitle?: string
  twitterDescription?: string
  twitterImage?: string
}

type Props = {
  isPublic?: boolean
  metadataOverrides?: MetadataOverrideProps
}

export const CorePageMetaTitle: React.FC<Props> = ({
  isPublic,
  metadataOverrides,
}) => {
  const { currentNavItem } = useNavigation()
  const { t } = useLocale()

  const title = useMemo(() => {
    const pageTitle = t(currentNavItem?.title)
    return pageTitle ? `BuildPass - ${pageTitle}` : 'BuildPass'
  }, [currentNavItem, t])

  return (
    <Head>
      <title>{title}</title>
      {/* <meta property="og:title" content={title} key="title" /> */}

      {/* Open Graph / Facebook metadata */}
      {/* Specifies that this is a website */}
      <meta property="og:type" content="website" />
      {/* The canonical URL of your site */}
      {!isPublic && (
        <meta property="og:url" content="https://buildpass.com.au/" />
      )}
      {/* The title of your site for social sharing */}
      <meta
        property="og:title"
        content={
          metadataOverrides?.ogTitle ||
          title ||
          'BuildPass - Construction Management test'
        }
      />
      {/* The description of your site for social sharing */}
      <meta
        property="og:description"
        content={
          metadataOverrides?.ogDescription ||
          'Streamline your construction projects with BuildPass'
        }
      />
      {/* The image to display when your site is shared on social media */}
      <meta
        property="og:image"
        content={
          metadataOverrides?.ogImage ||
          'https://app.buildpass.com.au/icons/512x512.png'
        }
      />

      {/* Twitter Card metadata */}
      {/* Specifies the card type, here it's a large image card */}
      <meta property="twitter:card" content="summary_large_image" />
      {/* The URL of your site */}
      <meta property="twitter:url" content="https://buildpass.com.au/" />
      {/* The title of your site for Twitter sharing */}
      <meta
        property="twitter:title"
        content={
          metadataOverrides?.twitterTitle ||
          'BuildPass - Construction Management'
        }
      />
      {/* The description of your site for Twitter sharing */}
      <meta
        property="twitter:description"
        content={
          metadataOverrides?.twitterDescription ||
          'Streamline your construction projects with BuildPass'
        }
      />
      {/* The image to display when your site is shared on Twitter */}
      <meta
        property="twitter:image"
        content={
          metadataOverrides?.twitterImage ||
          'https://app.buildpass.com.au/icons/512x512.png'
        }
      />
    </Head>
  )
}

export const CorePageLoadingTitle: React.FC = () => {
  return (
    <Head>
      <title>Loading BuildPass...</title>
    </Head>
  )
}
